/**
 * Agent Users API Client for Admin Dashboard
 * Stats-only endpoint (admin aggregation)
 */

import apiClient from './client';

// Types
export interface AgentUserStats {
  total_users: number;
  playground_users: number;
  real_users: number;
  active_users_24h: number;
  total_threads: number;
  total_messages: number;
  total_tokens: number;
  users_by_tier: Record<string, number>;
  total_storage_bytes: number;
  total_documents: number;
  total_memories: number;
  // Percentage changes (compared to previous period)
  users_change: number;
  messages_change: number;
}

export type SourceFilter = 'real' | 'playground' | undefined;

/**
 * Agent Users API - Admin stats only
 */
export const agentUsersApi = {
  /**
   * Get user statistics
   */
  async getStats(source?: SourceFilter): Promise<AgentUserStats> {
    const params = source ? { source } : {};
    const response = await apiClient.get<AgentUserStats>('/agent-users/stats', { params });
    return response.data;
  },
};

export default agentUsersApi;
